class Actions {
    static toggleVideoState = (source, video) => {
        if(video.paused){
            source.classList.add('video-playing');
            video.play();
        }
        else{
            source.classList.remove('video-playing');
            video.pause();
            
        }
    }
}